import { FC } from 'react';
import { Spin as AntSpin } from 'antd';
import { SpinProps, SpinIndicator } from 'antd/lib/spin'
import { Ring } from '@uiball/loaders'

interface IProps extends Omit<SpinProps, "indicator" | "size"> {
  size?: "default" | "large" | "small" | number;
  color?: string;
  indicator?: SpinIndicator
}

const spinSize: Record<"large" | "default" | "small", number> = {
  "large": 40,
  "default": 28,
  "small": 18,
}

const Spin: FC<IProps> = ({ size = "default", color = 'var(--primary-blue)', indicator, ...otherProps }) => {
  return (
    <AntSpin
      indicator={
        indicator ||
        <Ring
          color={color}
          size={typeof size === 'number' ? size :spinSize[size]}
          lineWeight={4}
        />
      }
      {...otherProps}
    />
  )
}

export default Spin;